import { useTranslation } from "@next-platform/client-common-core";
import { Text as SpicyText, TextArea, TextVariants } from "@next-platform/client-common-spicy-ui";
import React from "react";

import Trans from "@/components/Trans/Trans";

type ConversationImagePromptFieldsProps = {
  userPromptSuffix: string;
  userNegativePrompt: string;
  onUserPromptSuffixChange: (newUserPromptSuffix: string) => void;
  onUserNegativePromptChange: (newUserNegativePrompt: string) => void;
};

/** Advanced prompt settings: user prompt suffix and negative prompt. */
const ConversationImagePromptFields = ({
  userPromptSuffix,
  userNegativePrompt,
  onUserPromptSuffixChange,
  onUserNegativePromptChange,
}: ConversationImagePromptFieldsProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="leading-5">
        <SpicyText variant={TextVariants.PARAGRAPH_XSMALL_BOLD}>
          <Trans i18nKey="chat:modal.imageSettings.advancedPromptSettings" />
        </SpicyText>
      </div>
      <div>
        <SpicyText variant={TextVariants.LABEL_XSMALL_REGULAR}>
          <Trans i18nKey="chat:modal.imageSettings.advancedPrompts.description" />
        </SpicyText>
      </div>

      <div className="leading-5">
        <SpicyText variant={TextVariants.PARAGRAPH_XSMALL_REGULAR}>
          <Trans i18nKey="chat:modal.imageSettings.promptSuffix.label" />
        </SpicyText>
      </div>
      <div>
        <TextArea
          value={userPromptSuffix}
          onChange={onUserPromptSuffixChange}
          placeholder={t("chat:modal.imageSettings.promptSuffix.placeholder")}
          autoResize
          rows={1}
          className="w-full placeholder:text-[10px]"
        />
      </div>

      <div className="leading-5">
        <SpicyText variant={TextVariants.PARAGRAPH_XSMALL_REGULAR}>
          <Trans i18nKey="chat:modal.imageSettings.negativePrompt.label" />
        </SpicyText>
      </div>
      <div className="pb-2">
        <TextArea
          value={userNegativePrompt}
          onChange={onUserNegativePromptChange}
          placeholder={t("chat:modal.imageSettings.negativePrompt.placeholder")}
          autoResize
          rows={1}
          className="w-full placeholder:text-[10px]"
        />
      </div>
    </>
  );
};

export default React.memo(ConversationImagePromptFields);
